import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

function ThemeToggle() {
  const [theme, setTheme] = useState("light");

  useEffect(() => {
    setTheme(document.documentElement.dataset.theme || "light");
  }, []);

  useEffect(() => {
    const preference = window.matchMedia?.("(prefers-color-scheme: dark)");
    const followSystem = (event) => {
      try {
        if (localStorage.getItem("weizhi-theme")) return;
      } catch (e) {}
      const next = event.matches ? "dark" : "light";
      document.documentElement.dataset.theme = next;
      const meta = document.querySelector('meta[name="theme-color"]');
      if (meta) meta.content = next === "dark" ? "#292c29" : "#fbfbf8";
      setTheme(next);
    };
    preference?.addEventListener("change", followSystem);
    return () => preference?.removeEventListener("change", followSystem);
  }, []);

  const toggle = () => {
    const next = theme === "dark" ? "light" : "dark";
    try { localStorage.setItem("weizhi-theme", next); } catch (e) {}
    document.documentElement.dataset.theme = next;
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.content = next === "dark" ? "#292c29" : "#fbfbf8";
    setTheme(next);
  };

  return (
    <button className="theme-toggle interactive-only" type="button" onClick={toggle}
      aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
      title={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" aria-hidden="true">
        {theme === "dark" ? <>
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2m0 16v2M2 12h2m16 0h2M5 5l1.5 1.5m11 11L19 19M5 19l1.5-1.5m11-11L19 5" />
        </> : <path d="M20.5 14A8.5 8.5 0 0 1 10 3.5 8.5 8.5 0 1 0 20.5 14Z" />}
      </svg>
    </button>
  );
}

const Header = () => {
  return (
    <header className="site-header">
      <NavLink className="brand-link" to="/" aria-label="Weizhi Works home">
        <img
          className="brand-mark"
          src={`${process.env.PUBLIC_URL}/favicon.svg`}
          alt=""
          width="32"
          height="32"
        />
        <span>Weizhi Works</span>
      </NavLink>
      <nav className="site-nav" aria-label="Main navigation">
        <ul>
          <li>
            <NavLink to="/">
              Work
            </NavLink>
          </li>
          <li>
            <NavLink to="/about">
              About
            </NavLink>
          </li>
          <li>
            <a
              href="https://photos.weizhi.me"
              target="_blank"
              rel="noopener noreferrer"
            >
              Photos
            </a>
          </li>
          <li><ThemeToggle /></li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
